export default __webpack_public_path__ + "static/media/hht1_ep01_timeline_q01_a.55363510.png";